import { useFormContext } from 'dynamic-uniforms'
import { ComponentType, Fragment, createElement } from 'react'
import AutoField from './AutoField'
import { useCiboAutoForm } from './CiboAutoFormContext'

export type AutoFieldsProps = {
  element?: ComponentType | string
  fields?: string[]
  omitFields?: string[]
  showInlineError?: boolean
}

export const AutoFields = ({
  element = Fragment,
  fields,
  omitFields = [],
  showInlineError,
  ...props
}: AutoFieldsProps) => {
  const { bridge } = useFormContext()
  const { warnings } = useCiboAutoForm()

  return createElement(
    element,
    props,
    (fields ?? bridge.getSubfields())
      .filter((field: string) => !omitFields.includes(field))
      .map((field: string) => {
        return createElement(
          AutoField,
          Object.assign(
            { key: field, name: field, warning: warnings?.[field] },
            showInlineError === undefined ? null : { showInlineError }
          )
        )
      })
  )
}
